<template>
  <div class="pa-2">
    <div class="mb-10">
      <v-card class="mt-2 mb-4 pa-4" color="#ebebeb" flat :loading="loading">
        <div
          class="d-flex flex-row flex-wrap justify-space-between align-center"
        >
          <div>
            <div class="text-h5">{{ pageTitle }}</div>
          </div>
          <div>
            <!-- <v-btn
              depressed
              @click="doDelete()"
              color="red"
              text
              v-if="!newItem"
            >
              Delete</v-btn
            > -->
            <v-btn depressed @click="exitPage()" class="mx-2" text>
              Cancel</v-btn
            ><v-btn
              depressed
              color="primary"
              class="mx-2"
              @click="doSave()"
              text
            >
              Save</v-btn
            >
          </div>
        </div>

        <div class="caption d-flex flex-row flex-wrap align-center" v-if="data">
          <div class="mx-3" v-if="!newItem">id: {{ data.id }}</div>
          <div class="mx-3" v-if="data.clicks">Clicks: {{ data.clicks }}</div>
          <div class="mx-3" v-if="data.views">Views: {{ data.views }}</div>
          <div class="mx-3" v-if="data.added">Added: {{ data.added }}</div>
          <div class="mx-3" v-if="data.updated">
            Updated: {{ data.updated }}
          </div>
          <v-checkbox
            class="mx-3 my-0 py-0"
            v-model="data.published"
            dense
            :hide-details="true"
            label="Publish"
          ></v-checkbox>
        </div>
      </v-card>
      <v-alert v-if="error" type="warning">{{ error }}</v-alert>
      <!-- <v-alert type="warning" v-if="error">{{ error }}</v-alert> -->
      <v-form v-model="valid" v-if="data" class="mb-2 daForm" lazy-validation>
        <v-text-field
          label="Name this ad (For internal reference)"
          v-model="data.name"
          hide-details="auto"
          outlined
          class="mr-2 my-2"
        ></v-text-field>
        <v-combobox
          :items="localCompanies"
          v-model="data.company"
          outlined
          class="mr-2 my-2"
          hide-details="auto"
          label="Company (Choose from list or enter new)"
        ></v-combobox>
        <div class="d-flex flex-row align-center">
          <v-text-field
            label="Website (Where the user goes when ad clicked)"
            v-model="data.url"
            hide-details="auto"
            outlined
            class="mr-2 my-2"
          ></v-text-field>
          <div v-if="data.url" class="">
            <a :href="data.url" target="_blank"
              >Open<v-icon color="primary" small class="mx-1"
                >mdi-open-in-new</v-icon
              >
            </a>
          </div>
        </div>
        <div class="overline">Ad running time</div>

        <div class="d-flex flex-row flex-wrap">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="data.starts"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="data.starts"
                label="Start Date"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                outlined
                required
                class="mr-2"
              ></v-text-field>
            </template>
            <v-date-picker v-model="data.starts" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu1.save(data.starts)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="data.expires"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="data.expires"
                label="Expire Date"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                outlined
                messages="(leave empty to run ad indefinitely)"
                class="mr-2"
              ></v-text-field>
            </template>
            <v-date-picker v-model="data.expires" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu2 = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu2.save(data.expires)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
        <!-- <v-radio-group v-model="textAdType" label="Ad Type" row>
          <v-radio label="Image" :value="false"></v-radio>
          <v-radio label="Text" :value="true"></v-radio>
        </v-radio-group> -->
        <v-fade-transition>
          <md-textarea
            v-model="data.html"
            maxWidth="500"
            v-if="textAdType"
          ></md-textarea>
          <image-browser-uploader
            v-else
            :previousFiles="data.file ? [data.file] : []"
            :fileNameRoot="'ad_' + itemId"
            :limit="1"
            path="/images/eyedock_ads/"
            @fileList="newImageFiles = $event"
            class="my-1"
            title="Ad Image"
          ></image-browser-uploader>
        </v-fade-transition>
      </v-form>
    </div>
    <v-snackbar v-model="updatedSnackbar" :timeout="2000" top color="success">
      Ad Updated</v-snackbar
    >
    <v-snackbar v-model="deletedSnackbar" :timeout="2000" top color="alert">
      Ad Deleted</v-snackbar
    >
    <!-- {{ dataToReturn }} -->
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import MdTextarea from "@/components/adminStuff/MdTextarea";
import ImageBrowserUploader from "../ImageBrowserUploader.vue";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "EditAd",
  components: {
    MdTextarea,
    ImageBrowserUploader,
  },
  mixins: [UserMixin],
  props: {
    itemId: null,
    companies: null,
  },
  data: function () {
    return {
      apiPath: "/ads/addUpdate",
      error: null,
      updatedSnackbar: false,
      deletedSnackbar: false,
      loading: false,
      valid: null,
      pageTitle: "New Ad",
      data: null,
      localCompanies: [],
      menu1: false,
      menu2: false,
      textAdType: false,
      start_end: [],
      newImageFiles: [],
      defaultData: {
        id: 0,
        name: null,
        company: null,
        file: null,
        html: "",
        url: null,
        more_content: null,
        published: 1,
        clicks: 0,
        views: 0,
        starts: true,
        expires: null,
        added: null,
        updated: null,
      },
    };
  },
  methods: {
    getData() {
      if (!this.itemId) return;
      this.loading = true;
      let params = `id=${this.itemId}`;
      //   console.log(params);
      // ApiServices.getAds(params)
      ApiServices.genericApiCall("/ads/getAds?admin=1&" + params)
        .then((response) => {
          let rd = response.data;
          if (rd?.items) {
            this.pageTitle = rd.items.name;
            this.populateContentFromAPI(rd.items);
            if (rd.meta?.companies) this.localCompanies = rd.meta.companies;
          }

          this.error = null;
        })
        .catch((error) => {
          console.log(error);
          this.data = null;
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetAll: function () {
      this.data = { ...this.defaultData };
      this.data.starts = new Date().toISOString().slice(0, 10);
      this.pageTitle = "Add Ad";
    },
    populateContentFromAPI(data) {
      if (data?.published) data.published = parseInt(data.published);
      if (data.starts && data.expires)
        this.start_end = [data.starts, data.expires];
      this.data = data;
    },
    saveDate(ref, date) {
      this.$refs[ref].save(date);
    },

    exitPage() {
      this.$router.push({ path: "/boss/ads" });
    },
    doSave() {
      this.crudAPI(this.dataToReturn);
    },
    doDelete() {
      var confirmVar = confirm(
        "Are you sure you want to delete this ad? This cannot be undone"
      );
      if (confirmVar) {
        let data = { id: this.dataToReturn.id, delete: true };
        this.crudAPI(data);
      }
    },
    crudAPI(data) {
      let auth = this.auth_credentials;
      data.auth = auth;
      ApiServices.genericUpdateItem(this.apiPath, data)
        .then((response) => {
          if (response.data.error) {
            this.error = response.data.error;
          } else if (response.data.success) {
            this.error = null;
            data.delete
              ? (this.deletedSnackbar = true)
              : (this.updatedSnackbar = true);

            this.exitPage();
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        })
        .finally(() => {});
    },
  },
  computed: {
    newItem: function () {
      return !this.itemId || this.itemId == "new";
    },
    dataToReturn: function () {
      let rtn = this.data;
      if (this.newItem) rtn.id = 0;
      rtn.auth = this.auth_credentials;
      let imgs = this.newImageFiles;
      rtn.file = imgs && imgs.length > 0 ? imgs[0] : null;
      return rtn;
    },
  },
  mounted() {
    if (!this.newItem) {
      this.getData();
    } else {
      // console.log("new item");
      this.resetAll(); // uses default data
    }
    if (this.companies) this.localCompanies = this.companies;
  },
  metaInfo() {
    return {
      title: "EyeDock Ad Admin - " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.daForm {
  max-width: 700px;
}
</style>
